/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Studio_Marker_DescriptionInputs */

const en_ui_studio_marker_description = /** @type {(inputs: Ui_Studio_Marker_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description`)
};

const de_ui_studio_marker_description = /** @type {(inputs: Ui_Studio_Marker_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beschreibung`)
};

/**
* | output |
* | --- |
* | "Description" |
*
* @param {Ui_Studio_Marker_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_studio_marker_description = /** @type {((inputs?: Ui_Studio_Marker_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Studio_Marker_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_studio_marker_description(inputs)
	return de_ui_studio_marker_description(inputs)
});